import { cn } from '@kar-dmp/ignite';

export const Container = ({ children, className, verticallyCentered, ...props }) => (
	<div
		{...props}
		className={cn(
			'flex justify-center p-4 md:p-[45px]!',
			verticallyCentered ? 'items-center' : 'items-start',
			className,
		)}
	>
		{children}
	</div>
);

export const ContentContainer = ({ children, className, ...props }) => (
	<div {...props} className={cn('z-[2] flex h-fit rounded-lg bg-white p-8 shadow-md', className)}>
		{children}
	</div>
);
